import { GrocyBasics } from '../../../../core/entities/grocy/shared/basics.entity';
import { BaseForm } from '../../../../forms/forms/base.form';
import { GrocyDashboardShoppingSessionFormControls } from '../form-controls/dashboard-shopping-session.form-controls';

export class GrocyDashboardShoppingSessionForm extends BaseForm<GrocyDashboardShoppingSessionFormControls> {
  formGroup = this.createFormGroup(GrocyDashboardShoppingSessionFormControls);

  get date(): Date {
    return this.controls.date.value;
  }

  get store(): GrocyBasics | null {
    return this.controls.store.value;
  }
}
